import { Network } from '../../../utils/network'
import { Events } from '../../../utils/servicesEvents'
import { Formatter } from '../formatter'

import urls from './urls.json'

async function downloadCoupons(onSuccessEvent, onErrorEvent) {
  const response = await sendRequest()
  const parsedResponse = parseResponse(response, Formatter)
  const onDoneEvent = parsedResponse.success ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(onDoneEvent, parsedResponse)
}

async function sendRequest() {
  const url = urls.coupons
  const response = await Network.sendGetRequest(url)
  return response
}

function parseResponse(response) {
  if (
    response &&
    (response.status.code === 200 || response.status.code === 201)
  ) {
    const rawData = response.response
    const appData = Formatter.parseExternalCoupons(rawData)

    return {
      success: true,
      data: appData,
    }
  }
  if (response === null || response.status.code === 401) {
    return {
      success: false,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { downloadCoupons }
